// AUTO-GENERATED: 2025-10-28T19:10:34.718612Z
// 🌮 Mexican recipes

export const mexicanRecipes = [
{
    name: "Beef Tacos",
    cuisine: "Mexican",
    ingredients: ["ground beef", "tomatoes", "lettuce", "onion", "cheese", "corn tortillas"],
    sauces: ["salsa", "sour cream", "hot sauce", "taco seasoning"],
    instructions: "Brown ground beef in skillet. Add taco seasoning and water, simmer until thickened. Warm tortillas in dry skillet or microwave. Fill tortillas with seasoned beef. Top with shredded lettuce, diced tomatoes, chopped onion, shredded cheese, salsa, and sour cream. Serve immediately with lime wedges.",
    time: "20 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Chicken Quesadilla",
    cuisine: "Mexican",
    ingredients: ["chicken breast", "flour tortillas", "cheese", "bell peppers", "onion"],
    sauces: ["salsa", "sour cream", "guacamole"],
    instructions: "Cook chicken, shred or dice. Sauté bell peppers and onions. Place tortilla in skillet, add cheese, chicken, vegetables. Top with another tortilla. Cook 2-3 minutes per side until golden and cheese melts. Cut into wedges. Serve hot with salsa, sour cream, and guacamole for dipping.",
    time: "25 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Chicken Enchiladas",
    cuisine: "Mexican",
    ingredients: ["chicken breast", "corn tortillas", "cheese", "onion", "black beans"],
    sauces: ["enchilada sauce", "sour cream", "cilantro"],
    instructions: "Shred cooked chicken. Warm tortillas. Fill each with chicken, beans, cheese, and onions. Roll tightly, place seam-down in baking dish. Pour enchilada sauce over all. Top with more cheese. Bake at 375°F for 25 minutes until bubbly. Garnish with cilantro and sour cream. Serve hot with rice and beans.",
    time: "45 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Guacamole",
    cuisine: "Mexican",
    ingredients: ["avocados", "tomatoes", "onion", "cilantro", "jalape\u00f1o"],
    sauces: ["lime juice", "salt"],
    instructions: "Mash ripe avocados with fork to desired consistency. Add finely diced tomatoes, onion, jalapeño, and cilantro. Squeeze fresh lime juice over top. Season with salt to taste. Mix gently. Serve immediately with tortilla chips. Press plastic wrap directly on surface to prevent browning if storing.",
    time: "10 min",
    difficulty: "Easy",
    points: 25,
    servings: 2
  },
{
    name: "Burrito Bowl",
    cuisine: "Mexican",
    ingredients: ["rice", "black beans", "chicken breast", "corn", "tomatoes", "lettuce", "cheese"],
    sauces: ["salsa", "sour cream", "lime crema", "cilantro"],
    instructions: "Cook rice with lime juice and cilantro. Grill seasoned chicken, slice. Warm black beans. Assemble bowl: start with rice, add beans, chicken, corn, diced tomatoes, lettuce, and cheese. Top with salsa, sour cream, and guacamole. Squeeze fresh lime over everything. Serve immediately.",
    time: "30 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Carnitas",
    cuisine: "Mexican",
    ingredients: ["pork shoulder", "onion", "garlic", "orange"],
    sauces: ["cumin", "oregano", "lime juice", "salsa verde"],
    instructions: "Cut pork into chunks. Season with salt, cumin, oregano. Place in slow cooker with onion, garlic, and orange juice. Cook on low 8 hours until very tender. Shred pork. Broil on baking sheet 5-10 minutes to crisp edges. Serve in tortillas with cilantro, onion, salsa verde, and lime wedges.",
    time: "480 min",
    difficulty: "Medium",
    points: 100,
    servings: 2,
    special: true
  },
{
    name: "Nachos Supreme",
    cuisine: "Mexican",
    ingredients: ["tortilla chips", "ground beef", "cheese", "jalape\u00f1os", "tomatoes", "onion", "black beans"],
    sauces: ["sour cream", "salsa", "guacamole", "queso"],
    instructions: "Brown ground beef with taco seasoning. Arrange chips on large oven-safe platter. Layer with beans, beef, and shredded cheese. Bake at 400°F for 8-10 minutes until cheese melts. Top with jalapeños, diced tomatoes, onions. Drizzle with sour cream and queso. Serve immediately with salsa and guacamole.",
    time: "20 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Chile Rellenos",
    cuisine: "Mexican",
    ingredients: ["poblano peppers", "cheese", "eggs", "flour"],
    sauces: ["tomato sauce", "enchilada sauce"],
    instructions: "Roast poblanos until charred. Steam in covered bowl 10 minutes, peel skins. Make slit, remove seeds. Stuff with cheese, fold closed. Beat egg whites to stiff peaks, fold in yolks. Dust peppers with flour, dip in egg batter. Fry until golden. Serve with warm tomato sauce.",
    time: "45 min",
    difficulty: "Hard",
    points: 100,
    servings: 2
  },
{
    name: "Pozole",
    cuisine: "Mexican",
    ingredients: ["pork shoulder", "hominy", "onion", "garlic", "cabbage", "radishes"],
    sauces: ["chile sauce", "oregano", "lime juice"],
    instructions: "Simmer pork with onion and garlic in water for 2 hours until tender. Shred pork, return to pot. Add hominy, chile sauce, and oregano. Simmer 30 minutes. Serve in bowls with shredded cabbage, sliced radishes, oregano, lime wedges, and tostadas on the side.",
    time: "150 min",
    difficulty: "Medium",
    points: 100,
    servings: 2
  },
{
    name: "Fish Tacos",
    cuisine: "Mexican",
    ingredients: ["white fish", "cabbage", "corn tortillas", "lime"],
    sauces: ["chipotle mayo", "cilantro", "hot sauce"],
    instructions: "Season fish with cumin, chili powder, salt. Pan-fry or grill 3-4 minutes per side until cooked through. Break into chunks. Warm tortillas. Fill with fish, shredded cabbage, and pico de gallo. Drizzle with chipotle mayo. Garnish with cilantro and lime wedges. Serve immediately.",
    time: "25 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  }
];
